// extracted by mini-css-extract-plugin
module.exports = {"fullscreenModal":"GenericModal_fullscreenModal__2PReX","modalContainer":"GenericModal_modalContainer__1SH8_"};